import React from 'react';
import { MDBDataTable } from 'mdbreact';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import '../../style/DataTable.css';
import {
  createDateFromBackendDate,
  formatBackendDateEtLocale,
  getCurrentDateWithZeroTime,
} from '../../util/dateUtil';
import { isForfeitMatch, forfeitScore } from '../../util/forfeitUtil';

const MatchDaysDataTable = (props) => {
  const setBoldIfCurrentTeam = (currentTeam, teamFromData) => {
    return currentTeam === teamFromData ? (
      <div style={{ fontWeight: 800 }}>{teamFromData}</div>
    ) : (
      teamFromData
    );
  };

  const isPlayed = (row) => {
    return (
      row.homePoints !== null &&
      row.awayPoints !== null &&
      row.homeTotal !== null &&
      row.awayTotal !== null
    );
  };

  const getMatchDayMatchesData = () => {
    let rowData = [];
    props.matchDayMatches
      .sort(
        (first, second) =>
          createDateFromBackendDate(
            first.matchDateTime == null
              ? getCurrentDateWithZeroTime()
              : first.matchDateTime
          ) -
          createDateFromBackendDate(
            second.matchDateTime == null
              ? getCurrentDateWithZeroTime()
              : second.matchDateTime
          )
      )
      .map((row) =>
        rowData.push({
          homeTeamName: row.homeTeamName
            ? setBoldIfCurrentTeam(props.currentTeamName, row.homeTeamName)
            : 'N/A',
          awayTeamName: row.awayTeamName
            ? setBoldIfCurrentTeam(props.currentTeamName, row.awayTeamName)
            : 'N/A',
          matchDateTime: row.matchDateTime
            ? formatBackendDateEtLocale(row.matchDateTime)
            : 'N/A',
          combinedPoints: isForfeitMatch(row)
            ? forfeitScore(row)
            : isPlayed(row)
            ? `${row.homePoints}:${row.awayPoints} (${row.homeTotal}:${row.awayTotal})`
            : '',
          toDetails: isPlayed(row) ? (
            <Link to={`/match_details?match_id=${row.id}`}>
              <FontAwesomeIcon icon={faEye} />
            </Link>
          ) : (
            ''
          ),
        })
      );
    if (!rowData.length) {
      return null;
    }

    return {
      columns: [
        {
          label: 'Koduvõistkond',
          field: 'homeTeamName',
        },
        {
          label: 'Külalisvõistkond',
          field: 'awayTeamName',
        },
        {
          label: 'Aeg',
          field: 'matchDateTime',
        },
        {
          label: 'Tulemus',
          field: 'combinedPoints',
        },
        {
          label: 'Detailid',
          field: 'toDetails',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getMatchDayMatchesData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default MatchDaysDataTable;
